const prefix = 'app/patient-travel'

export default {
    storeRequisition: `/${prefix}/requisition`,
    validateRequisition: `/${prefix}/requisitions/validate`,
    getRequisition: `/${prefix}/requisition/{requisitionNumber}`,
    cancelRequisition: `/${prefix}/requisition/{requisitionNumber}/direction/{direction}/booking/{bookingId}`,
    listTypes: `/${prefix}/requisitions/types`,
    listTreatmentSiteFilters: `/${prefix}/treatment-sites/filters`,
    listTreatmentSites: `/${prefix}/treatment-sites/list`,
    getTreatmentSite: `/${prefix}/treatment-site/{id}`,
    listAddresses: `/${prefix}/requisitions/addresses`,
    getOffice: `/${prefix}/requisitions/office?postcode=`,
    preferences: `/${prefix}/preferences`,
}

// use to apply route params to a route
// example. const treatmentSiteUrl = formatRoute(routes.getTreatmentSite, { id: 42 })
export function formatRoute(route, params) {
    return route.replace(/{(\w+)}/g, (_, key) => params[key] || `{${key}}`)
}
